import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { Slide } from 'src/app/shared/components/mosaic/mosaic.inferface';
import { environment } from 'src/environments/environment';
import { HotelDetailGQL } from 'src/app/shared/graphql/hotel-detail.graphql';
import { property_property, property_property_images, property_property_roomTypes } from 'src/app/shared/graphql/types/property';
import { ViewportScroller } from '@angular/common';
import { GoogleMapStyles } from 'src/app/shared/config/googleMaps.config';
import { TenantService } from 'src/app/shared/services/tenent.service';
import { Title, Meta } from '@angular/platform-browser';
import dayjs from 'dayjs';

export enum BookingType {
  DATE = 'date',
  LOCATION = 'location',
}

@Component({
  selector: 'app-hotel-layout-one',
  templateUrl: './hotel-layout-one.component.html',
  styleUrls: ['./hotel-layout-one.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HotelLayoutOneComponent implements OnDestroy {
  private propertySubscription: Subscription;
  private routeSubscription: Subscription;
  loading: boolean = true;
  slides: Slide[] = [];
  assets_base: string = environment.assets_base;
  property: property_property;
  propertySlug: string;
  attractions: property_property_images[] = [];
  logo: property_property_images;
  front_desk_image: property_property_images;
  selectedDateRange: any;
  bookingType = BookingType;
  dtDrpPlacement: string;
  roomTypes: property_property_roomTypes[] = [];
  templateTheme: string;

  googleMapOptions: google.maps.MapOptions = {
    styles: GoogleMapStyles
  }
  mediaSub: Subscription;

  minDate = dayjs().format('YYYY-MM-DD');
  year = dayjs().format('YYYY');

  constructor(
    private hotelDetailGQL: HotelDetailGQL,
    private viewportScroller: ViewportScroller,
    private titleService: Title,
    private meta: Meta,
    private tenantService: TenantService,
  ) {
    this.propertySlug = this.tenantService.getTenant().propertyId;
    this.templateTheme = this.tenantService.getTenant().templateTheme;
    
    if (this.propertySlug) {
      this.getProperty();
    }
  }

  ngOnDestroy(): void {
    this.routeSubscription.unsubscribe();
    this.propertySubscription.unsubscribe();
    this.mediaSub.unsubscribe();

  }

  getProperty() {
    this.propertySubscription = this.hotelDetailGQL
      .watch({
        code: this.propertySlug,
      })
      .valueChanges
      .subscribe(({ data, loading }) => {
        this.loading = loading;
        if (data.property === null) {
          // console.log('NOT FOUND');
        } else {
          this.property = data.property;

          if(this.property.roomTypes) {
            this.roomTypes =  this.property.roomTypes.slice().sort((a, b) => a.sortOrder - b.sortOrder);
          }
          this.attractions = this.property.images
            .filter(entry => entry.accessCode === '003');
          this.titleService.setTitle(this.property.property.name);
          this.meta.addTags([  
            { name: 'title', content: `${this.property.property.name}, ${this.property.property.city} - Official Website` },
            { name: 'description', content: this.property.property.description },
            { name: 'robots', content: 'index, follow' }
          ]);

          this.getFeaturedImages('004');
          this.logo = this.getImage('007');
          this.front_desk_image = this.getImage('005');
        }
      });
  }

  getImage(accessCode: string) {
    return this.property.images.find(entry => entry.accessCode === accessCode);
  }

  getFeaturedImages(accessCode: string) {
    this.slides = this.property.images
      .filter(entry => entry.accessCode === accessCode || entry.accessCode === '001')
      .map(entry => {
        return {
          src: this.assets_base + entry.imagePath,
          headline: entry.caption,
          accessCode: entry.accessCode
        };
      }).sort((a, b) => {
        if (a.accessCode > b.accessCode) {
          return 1;
        }
        return -1;
      });
  }

  encodeUrl(string) {
    if (string) {
      return string.replace(/ /g, "%20");
    }
  }

  scrollTo(id: string) {
    this.viewportScroller.scrollToAnchor(id);
  }

  formatTime(time: string): string {
    const today = dayjs().format('YYYY-MM-DD');
    return dayjs(today + ' ' + time).format('hh:mm A');
  }
  

  bookNow(option: string = null, value: string = null) {
    let params = [];
    if (option == BookingType.DATE && this.selectedDateRange.startDate && this.selectedDateRange.endDate) {
      let checkin = dayjs(this.selectedDateRange.startDate).format('YYYY-MM-DD');
      let checkout = dayjs(this.selectedDateRange.endDate).format('YYYY-MM-DD');
      params.push('checkin=' + checkin);
      params.push('checkout=' + checkout);
    }

    if (option == BookingType.LOCATION) {
      params.push('rooms=' + value);
    }

    let bookNowURL = this.property.property.webUrl;
    if (bookNowURL) {
      if (params.length) {
        bookNowURL = bookNowURL + '&' + params.join('&');
      }
      window.open(bookNowURL, '_blank');
    }
  }
}
